<template>
  <!-- 线上 -->
  <div>
    <step1
      v-if="activeTab === 'step1'"
      :id.sync="id"
      :settlementStatus="settlementStatus"
      :reportType="reportType"
      ref="step1Ref"
      @next="nextStep"
    ></step1>

    <step2
      v-if="activeTab === 'step2'"
      :id="id"
      :settlementStatus="settlementStatus"
      :reportName="reportName"
      :reportType="reportType"
      @success="settlementStatus = '1'"
      @back="activeTab = 'step1'"
      ref="step2Ref"
    ></step2>
  </div>
</template>
  
  <script>
import step1 from './step1.vue';
import step2 from './step2.vue';

export default {
  components: {
    step1,
    step2
  },

  data() {
    return {
      id: '',
      activeTab: 'step1',
      isSummary: '',
      settlementStatus: '',
      reportType: 'basic',
      reportName: ''
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.settlementStatus = this.$route.query.settlementStatus;
    this.reportName = this.$route.query.reportName;
    this.settlementStatus = this.$route.query.settlementStatus;
    this.isSummary = this.$route.query.isSummary;
    this.reportType = this.$route.query.reportType || 'basic';
    this.activeTab = this.settlementStatus === '1' || this.isSummary == '1' ? 'step2' : 'step1';
  },
  methods: {
    nextStep(val, id) {
      console.log(val, id)
      this.id = id;
      this.reportName = val;
      this.activeTab = 'step2';
    }
  }
};
</script>
  <style lang="scss" scoped>
.bottom-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: #fff;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #ccc;

  .ivu-btn {
    width: 140px;
    height: 35px;
  }

  .ivu-btn + .ivu-btn {
    margin-left: 20px;
  }
}

/deep/ .ivu-input-wrapper-disabled .ivu-input-group-append {
  border: none;
  background-color: #f4f7fa;
}
</style>
  